export function Colorize(color) {
    if (CheckColor(color)) {
       let [red, green, blue] = color.slice(4,).replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').split(',')
        if ((red*0.299 + green*0.587 + blue*0.114) > 150)  {
            return '#000000'
        } else {
            return '#ffffff'
        }
    } else {
        return '#ff0000'
    }

}

function CheckColor(color) {
    const el = document.createElement('div');
    el.style.backgroundColor = color;
    return el.style.backgroundColor && color.includes('rgba') ? true : false;
}

export const palette = [
    'rgba(227, 90, 91, 0.7)', 'rgba(152, 61, 62, 0.7)',
    'rgba(90, 227, 228, 0.7)','rgba(61, 152, 153, 0.7)',
    'rgba(159, 227, 91, 0.7)','rgba(106, 152, 62, 0.7)',
    'rgba(159, 90, 228, 0.7)','rgba(106, 61, 153, 0.7)',
    'rgba(227, 193, 91, 0.7)','rgba(152, 129, 62, 0.7)',
    'rgba(90, 227, 126, 0.7)','rgba(61, 152, 84, 0.7)',
    'rgba(90, 125, 228, 0.7)','rgba(61, 83, 153, 0.7)',
    'rgba(227, 90, 194, 0.7)','rgba(152, 61, 130, 0.7)',
    'rgba(227, 142,91, 0.7)', 'rgba(152, 94, 62, 0.7)',
    'rgba(210, 227, 91, 0.7)','rgba(140, 152, 62, 0.7)',
    'rgba(108, 227, 91, 0.7)','rgba(71, 152, 62, 0.7)',
    'rgba(90, 227, 177, 0.7)','rgba(61, 152, 118, 0.7)',
    'rgba(90, 176, 228, 0.7)','rgba(61, 117, 153, 0.7)',
    'rgba(108, 90, 228, 0.7)','rgba(71, 61, 153, 0.7)',
    'rgba(210, 90, 228, 0.7)','rgba(140, 61, 153, 0.7)',
    'rgba(227, 90, 143, 0.7)','rgba(152, 61, 95, 0.7)'
]